var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"code-btn",attrs:{"type":"primary","size":"small","plain":"","disabled":!!_vm.timer},on:{"click":_vm.getCode}},[_vm._v(_vm._s(!!_vm.timer ? ("重新发送" + _vm.countdown) : "获取验证码"))])}
var staticRenderFns = []

export { render, staticRenderFns }